import React from "react";
import axios from "axios";
import DBConn from "~/Classes/siteVars.js";
import { connect } from "react-redux";
import queryString from "query-string";
import Button from "~/Common-Objects/UI/Forms/Button/Button";
import Icons from "~/Common-Objects/UI/Icons/index";
import LoadingIcons from "~/Common-Objects/LoadingIcons/loadingIcon1";
import Paper from "~/Common-Objects/UI/Paper/Paper";
import GoogleAnalytics from "../../Classes/googleAnalytics";
import helpers from "~/Classes/helpers";
import LandingPageTemplate from "../login/template";

@connect((store) => {
	return {
		user: store.user,
		siteMaster: store.siteMaster,
	};
})
export default class ActivateTemplate extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			invalid: false,
			linkUrl: "/",
		};
	}

	componentDidMount() {
		const query = queryString.parse(location.search);
		const ourToken = query.token;

		var baseUrl = DBConn.getConnString();

		if (!ourToken) {
			return this.props.history.push("/?invalid=true");
		}

		//lookup token and see if its a brand new user
		axios.put(baseUrl + "/register", { token: ourToken }).then(response => {
			if (query.redirect) {
				const redirect = helpers.safeRedirect(query.redirect, "return", null);
				const linkUrl = `${this.state.linkUrl}?redirect=${redirect}`;
				this.setState({ linkUrl, loading: false });
				this.timerId = setTimeout(() => this.autoRedirect(), 3000);
			} else {
				this.setState({ linkUrl: '/', loading: false });
				this.timerId = setTimeout(() => this.autoRedirect(), 3000);
			}
		}).catch(() => {
			this.props.history.push("/?invalid=true");
		})
	}

	componentWillUnmount() {
		clearTimeout(this.timerId);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.siteMaster && this.props.siteMaster) {
			if (
				prevProps.siteMaster.googleAnalyticsKey !=
				this.props.siteMaster.googleAnalyticsKey
			) {
				try {
					GoogleAnalytics.trackGAPageView(this.props.history.location.pathname);
				} catch (err) { }
			}
		}
	}

	autoRedirect() {
		console.log("Redirecting to: ", this.state.linkUrl);
		this.props.history.push(this.state.linkUrl);
	}

	render() {
		let header = '';
		let subheader = '';
		if (!this.state.loading) {
			header = "Verification successful";
			subheader = "Your account has been successfully verified. We will redirect you to login in a few seconds…";

		}
		return (
			<LandingPageTemplate
				header={header}
				subheader={subheader}
				paperClasses="landing-login"
				top={!this.state.loading && !this.state.invalid ?
					<div className="quickFlex" style={{ justifyContent: "center", marginBottom: 8 }}>
						<Icons style={{ height: 40, width: 40 }} color="var(--cyan-400)" icon="tickCircle" />
					</div> :
					''}
			>
				{this.state.loading && <div><LoadingIcons /></div>}
			</LandingPageTemplate>
		)


		if (this.state.loading) {
			return (
				<LoadingIcons
					iconType="2"
					style={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translateX(-50%) translateY(-50%)",
					}}
				/>
			);
		}

		return (
			<div
				className="quickFlex"
				style={{
					alignItems: "center",
					justifyContent: "center",
					height: "100vh",
				}}
			>
				{this.state.invalid ? (
					<Paper className="with_header">
						<div
							className="paper_header"
							style={{
								backgroundColor: this.props.siteMaster.colours["$primary"],
								color: "white",
							}}
						>
							<div className="quickFlex">
								<Icons
									icon="alert"
									color={"#FFFFFF"}
									style={{ width: "20px", height: "20px" }}
								/>
								<div className="mar-l10 text-heavy" style={{ fontSize: 16 }}>
									Something went wrong
								</div>
							</div>
						</div>
						<div className="paper_content">
							<div className="mar-b25">
								Link Expired, please login and request verification again
							</div>
							<Button
								text="Continue"
								onClick={() => {
									this.props.history.push("/");
								}}
							/>
						</div>
					</Paper>
				) : (
					<Paper>
						<p>
							Your account has been successfully verified. Redirecting you to
							login in a few seconds…
						</p>
					</Paper>
				)}
			</div>
		);
	}
}
